module.exports = __webpack_public_path__ + "static/media/msfs32_1951.db35ed8d.ico";